import type { Voice } from '@/features/voice/domain/models/voice.ts'
import type { Script } from '@/features/script/domain/models/script.ts'
import { createTTSSpeech } from '@/features/speech/domain/use-cases/create-tts-speech.ts'
import { getAudioBufferFromAudioUrl } from '@/utils/get-audio-buffer-from-audio-url'
import useMediaStore from '@/shared/store/media.store.tsx'
import { updateClip } from './update-clip.ts'
import { refreshAudioMix } from '@/shared/store/use-cases/refresh-audio-mix.ts'
import { useHistoryStore } from '@/shared/store/history.store.tsx'
import { calculateScriptDuration } from '@/utils/calculate-script-duration.ts'

export const updateVoiceClip = async (
  clipId: string,
  voice: Voice,
  script: Script,
  speed = 1,
  expressive = false
): Promise<void> => {
  const { addMedia } = useMediaStore.getState()

  updateClip(clipId, {
    name: voice.name,
    mediaId: '',
    duration: calculateScriptDuration(script.text),
  })

  // Generate new speech with updated parameters
  const { speechId, speechUrl } = await createTTSSpeech(
    script.id,
    voice,
    speed,
    expressive
  )
  const speechBuffer = await getAudioBufferFromAudioUrl(speechUrl)

  addMedia(speechId, speechBuffer)
  updateClip(clipId, {
    name: voice.name,
    mediaId: speechId,
    src: speechUrl,
    duration: speechBuffer.duration,
  })

  useHistoryStore.getState().saveSnapshot()
  void refreshAudioMix(false)
}
